export { default } from './BadgePartnerCar';
